import { gql } from '@apollo/client';

export const fetchSubscriptionOrderHistory = gql`
  query fetchSubscriptionOrderHistory($id: String, $searchOptions: ConnectionSearchOptions) {
    entitlementDetails(id: $id) {
      id
      orders(searchOptions: $searchOptions) {
        totalCount
        nodes {
          created
          orderLineItems {
            nodes {
              entitlementId
              status
              type
              offeringId
              orderTransitionType
              pricingPlan {
                billingFrequency
              }
            }
          }
        }
      }
    }
  }
`;
